import { render, staticRenderFns } from "./DemoRangeSliderThumbLabel.vue?vue&type=template&id=778322b8&"
import script from "./DemoRangeSliderThumbLabel.vue?vue&type=script&lang=js&"
export * from "./DemoRangeSliderThumbLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
installComponents(component, {VIcon,VRangeSlider})
